import { styled, CommonStyles } from '@teko/ds-foundation';

const Wrapper = styled.div(({ theme }) => [
  CommonStyles,
  `
  padding-left: ${theme == null ? void 0 : theme.spacing.s8};
  padding-right: ${theme == null ? void 0 : theme.spacing.s8};
  border: ${theme == null ? void 0 : theme.borderWeight.m} solid ${theme == null ? void 0 : theme.colors.border};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  width: fit-content;
  height: 40px;
  display: flex;
  justify-content: space-between;
  > * {
    align-self: center;
  }

  .rc-picker {
    margin-left: ${theme == null ? void 0 : theme.spacing.s4};
    &.rc-picker-focused {
      border: none;
    }
    .rc-picker-input {
      > input {
        border: none;
        &:focus {
          outline: none;
        }
      }

      .rc-picker-clear {
        right: 0;
      }
    }
    .rc-picker-dropdown {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-variant: tabular-nums;
      line-height: 1.5715;
      list-style: none;
      font-feature-settings: 'tnum';
      position: absolute;
      z-index: 1050;
      box-shadow: none !important;
    }
    
    .rc-picker-panel-container {
      overflow: hidden;
      vertical-align: top;
      background: #fff;
      border-radius: 2px;
      box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
      transition: margin 0.3s;
    
      .rc-picker-panel {
        vertical-align: top;
        background: 0 0;
        border-radius: 0;
        display: inline-flex;
        flex-direction: column;
        text-align: center;
        background: #fff;
        outline: none;
        border: none;
      }
    }
    
    .rc-picker-header {
      display: flex;
      padding: 0 8px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid #f0f0f0;
    }
    
    .rc-picker-header-view {
      flex: auto;
      font-weight: 500;
      line-height: 40px;
    
      button {
        color: inherit;
        font-weight: inherit;
        padding: 0;
        line-height: 40px;
        background: 0 0;
        border: 0;
        cursor: pointer;
        transition: color 0.3s;
    
        &:not(:first-of-type) {
          margin-left: 8px;
        }
      }
    }
    
    .rc-picker-header > button {
      min-width: 1.6em;
      padding: 0;
      color: rgba(0, 0, 0, 0.25);
      line-height: 40px;
      background: 0 0;
      border: 0;
      cursor: pointer;
      transition: color 0.3s;
    }
    
    .rc-picker-body {
      padding: 8px 12px;
    
      .rc-picker-content {
        width: 252px;
      }
    }
    
    .rc-picker-panel .rc-picker-footer {
      border-top: 1px solid #f0f0f0;
      width: min-content;
      min-width: 100%;
      line-height: 38px;
      text-align: center;
      border-bottom: 1px solid transparent;
      background: #fff;
      border-top: 1px solid #f0f0f0;
      width: min-content;
      min-width: 100%;
      line-height: 38px;
      text-align: center;
      border-bottom: 1px solid transparent;
      background: #fff;
    }
    
    .rc-picker-ranges {
      margin-bottom: 0;
      padding: 4px 12px !important;
      overflow: hidden;
      line-height: 34px;
      text-align: left;
      list-style: none;
    
      > li {
        display: inline-block;
      }
    }
    
    .rc-picker-now {
      text-align: left;
    }
    
    .rc-picker-ranges .rc-picker-ok {
      float: right;
      margin-left: 8px;
    }
    
    .rc-picker-dropdown .rc-picker-panel > .rc-picker-time-panel {
      padding-top: 4px;
    }
    
    .rc-picker-time-panel-column {
      flex: 1 0 auto;
      width: 56px !important;
      margin: 0;
      padding: 0;
      overflow-y: hidden;
      text-align: left;
      list-style: none;
      transition: background 0.3s;
    
      > li.rc-picker-time-panel-cell-selected .rc-picker-time-panel-cell-inner {
        background: #e6f7ff;
      }
    }
    
    .rc-picker-cell-inner, .rc-picker-time-panel-cell-inner {
      font-size: 14px;
    }
    
    .rc-picker-now-btn, .rc-picker-today-btn {
      cursor: pointer;
      color: #1890ff !important;
    }
    
    .rc-picker-time-panel-cell-inner:hover {
      background: #f5f5f5;
    }
    
    .rc-picker-cell-inner:hover {
      background-color: #f5f5f5 !important;
    }

    .rc-picker-time-panel-column:hover {
      overflow-y: auto;
    }
  }
`
]);

export { Wrapper };
